import React, { useState } from 'react';
import CenteredModal from '../../../common/CenteredModal';
import { PlusIcon } from '@heroicons/react/24/outline';

export function SeriesQuickCreate({ quickCreateData, setQuickCreateData, handleQuickCreate }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuickCreateData(prev => ({
      ...prev,
      series: {
        ...prev.series,
        [name]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!quickCreateData.series.name) return;
    
    setLoading(true);
    try {
      // Only use handleQuickCreate to create the series
      await handleQuickCreate('series');
      
      // Reset the form
      setQuickCreateData(prev => ({
        ...prev,
        series: { name: '' }
      }));
      
      setOpen(false);
    } catch (error) {
      console.error('Error creating series:', error);
      alert(`Error creating series: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ml-1 px-2 py-1 rounded bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-200 hover:bg-violet-200 dark:hover:bg-violet-800 transition"
        onClick={() => setOpen(true)}
        title="Neue Serie anlegen"
      >
        <PlusIcon className="w-5 h-5" />
      </button>
      <CenteredModal open={open} onClose={() => setOpen(false)} title="Neue Serie anlegen">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Name</label>
            <input
              type="text"
              name="name"
              value={quickCreateData.series.name}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button 
              type="button" 
              onClick={() => setOpen(false)} 
              className="px-4 py-2 rounded bg-gray-200 dark:bg-zinc-700 text-gray-800 dark:text-gray-200"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="button"
              onClick={handleSubmit}
              className="px-4 py-2 rounded bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Wird gespeichert...' : 'Anlegen'}
            </button>
          </div>
        </div>
      </CenteredModal>
    </>
  );
} 